import { useEffect } from 'react';
import { useAuthSessionQuery, useObserverEndMutation } from '@platform/features/auth';
import { baseApi } from '@platform/state/api';
import { useAppDispatch } from '@platform/state/hooks';
import type { IObserverLayerProps } from './IObserverLayerProps';
import { ObserverBanner } from './ObserverBanner';
import './observer.css';

/**
 * Шар режиму спостерігача над усім застосунком: поки сесія спостерігача триває (GET /auth/me → observer), на <html> стоїть
 * data-observer="1" (стилі «лише перегляд» — observer.css) і внизу показано банер; «Змінити особу» завершує сесію (DELETE
 * /observer/sessions), скидає кеш API і відкриває вибір особи над екраном входу (прототип v4 obsExit).
 */
export function ObserverLayer({ onSwitched }: IObserverLayerProps) {
  const dispatch = useAppDispatch();
  const { data } = useAuthSessionQuery();
  const [end, ending] = useObserverEndMutation();
  const observer = data?.observer === true;
  useEffect(() => {
    const root = document.documentElement;
    if (observer) root.dataset.observer = '1';
    else delete root.dataset.observer;
  }, [observer]);
  if (!observer || !data) return null;
  const switchPerson = () => {
    end().unwrap().catch(() => undefined).finally(() => {
      dispatch(baseApi.util.resetApiState());
      onSwitched();
    });
  };
  return <ObserverBanner name={data.user.displayName} busy={ending.isLoading} onSwitch={switchPerson} />;
}
